import { isString } from './isString';

import { LOCALE } from '../constants';

export function lowerCase(input, locale = LOCALE) {
  if (!isString(input)) return '';
  return input.toLocaleLowerCase(locale);
}
